// extracted by mini-css-extract-plugin
export default {"brazePlaceholder":"BrazeBannerPlaceholder_brazePlaceholder__mLK8Z"};